var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1954_1608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 7.94245C13.3603 7.80932 13.3335 7.67746 13.2806 7.55527C13.2278 7.43308 13.1501 7.32322 13.0525 7.23269L7.12502 1.76562L1.19757 7.23269C1.09995 7.32322 1.02225 7.43308 0.969411 7.55527C0.91657 7.67746 0.889746 7.80932 0.890647 7.94245V13.2752C0.890647 13.5296 0.991698 13.7736 1.17157 13.9534C1.35144 14.1333 1.59541 14.2344 1.84978 14.2344H12.4002C12.6546 14.2344 12.8986 14.1333 13.0784 13.9534C13.2584 13.7736 13.3594 13.5296 13.3594 13.2752V7.94245Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.33594,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 14.2343V10.3978",
    stroke: "#EFFEF5",
    strokeWidth: 1.33594,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1954_1608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.25,
    height: 14.25,
    fill: "white",
    transform: "translate(0 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.502176b85a6a5654aabe71de2f9354a6.svg";
export { ForwardRef as ReactComponent };